module.exports = __webpack_public_path__ + "media/game-video.d907780d.mp4";